import { TextField } from '@mui/material'
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'

import dateUtils from '../../../_helpers/dateUtils'
import translateUtils from '../../../_helpers/translateUtils'

const DateInput = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    isValid: () => !(props.required && !value.length),
  }))
  const [value, setValue] = useState(dateUtils.formatDatePicker(props.value))
  useEffect(() => {
    let isValid = true
    if (props.required && !value.length) isValid = false
    props.setIsValids((s) => {
      s[props.index] = isValid
      return s
    })
    if (isValid)
      props.setIsValid(
        props.isValids.reduce((isAllValid, key, i) => {
          if (i === props.index) return isAllValid && isValid
          return isAllValid && key
        }, true)
      )
    else props.setIsValid(false)
    // When the picked date matches the stored value's date, emit the ORIGINAL
    // timestamp untouched. Without this, the date-only picker round-trips
    // every existing datetime through midnight (and via a local-vs-UTC parse
    // asymmetry, sometimes the previous day) — so every full-form save
    // silently rewrote publishedAt/createdAt even when nobody touched them.
    const unchanged =
      props.value && value === dateUtils.formatDatePicker(props.value)
    props.setBody((s) => ({
      ...s,
      [props.name]: value
        ? unchanged
          ? props.value
          : new Date(value).toISOString()
        : null,
    }))
  }, [value])
  return (
    <TextField
      margin="normal"
      label={translateUtils.translate(props.label)}
      type="date"
      fullWidth
      InputLabelProps={{ shrink: true }}
      autoFocus={props.index === 0}
      disabled={props.disabled}
      value={value}
      onChange={(event) =>
        setValue(dateUtils.formatDatePicker(event.target.value))
      }
      required={props.required}
      error={props.required && !value.length}
      {...(props.required &&
        !value.length && {
          helperText: `${translateUtils.translate(
            props.label
          )} ${translateUtils.translate('is required')}`,
        })}
    />
  )
})
export default DateInput
